import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { pdfjs, Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import FileSaveer from 'file-saver';
import printJS from 'print-js';
import {
  IconButton, Icon, Card, CardContent, withStyles, Menu, MenuItem,
} from '@material-ui/core';
import moment from 'moment';

import Measure from 'react-measure';

import { CardHeader, LoadingIndicator } from '../../../../components';
import Button from '../../../../components/button/button';


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const contentPadding = 16;
const documentBorderSize = 1;


const styles = {
  actions: {
    display: 'flex',
  },
  actionGroup: {
    display: 'flex',
  },
  buttonLeft: {
    paddingRight: 3,
  },
  buttonRight: {
    paddingLeft: 3,
  },
  buttonInner: {
    width: 15,
    paddingLeft: 0,
    paddingRight: 0,
  },
  card: {
    height: 'calc(100vh - 120px)',
    display: 'flex',
    flexDirection: 'column',
  },
  cardInApp: {
    height: 'calc(100vh - 15px)',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    overflow: 'auto',
    padding: `${contentPadding}px`,
    flexGrow: 1,
  },
  document: {
    border: `${documentBorderSize}px solid #efefef`,
    margin: 'auto',
  },
  textButton: {
    margin: 8,
  },
};


const pageSelector = ({ changeToPage, pageNumber, numPages }) => (
  <div key="pageSelector" style={styles.actionGroup}>
    <IconButton
      style={styles.buttonLeft}
      disabled={pageNumber === 1}
      onClick={() => changeToPage(1)}
    >
      <Icon>
        keyboard_double_arrow_left
      </Icon>
    </IconButton>
    <IconButton
      style={styles.buttonInner}
      disabled={pageNumber <= 1}
      onClick={() => changeToPage(pageNumber - 1)}
    >
      <Icon>
        keyboard_arrow_left
      </Icon>
    </IconButton>
    <p>
      Seite
      {' '}
      {pageNumber || (numPages ? 1 : '--')}
      /
      {numPages || '--'}
    </p>
    <IconButton
      style={styles.buttonInner}
      disabled={pageNumber >= numPages}
      onClick={() => changeToPage(pageNumber + 1)}
    >
      <Icon>
        keyboard_arrow_right
      </Icon>
    </IconButton>
    <IconButton
      style={styles.buttonRight}
      disabled={pageNumber === numPages}
      onClick={() => changeToPage(numPages)}
    >
      <Icon>
        keyboard_double_arrow_right
      </Icon>
    </IconButton>
  </div>
);

const zoomSelector = ({ zoom, setZoom }) => (
  <div key="zoomSelector" style={styles.actionGroup}>
    <IconButton
      style={styles.buttonLeft}
      disabled={zoom <= 10}
      onClick={() => setZoom(zoom - 10)}
    >
      <Icon>
        zoom_out
      </Icon>
    </IconButton>
    <p>
      {zoom}
      %
    </p>
    <IconButton
      style={styles.buttonRight}
      onClick={() => setZoom(zoom + 10)}
    >
      <Icon>
        zoom_in
      </Icon>
    </IconButton>
  </div>
);

const header = ({
  numPages,
  pageNumber,
  changeToPage,
  zoom,
  setZoom,
  data,
  anchorEl,
  setAnchorEl,
  useDesktopLayout,
  inApp,
  title,
  dateRange,
  downloadCsvReportData,
  reportWidgetID,
  supportsCsvExport,
  isLoadingCsvExport,
}) => {
  const actions = [
    pageSelector({ numPages, pageNumber, changeToPage }),
    zoomSelector({ zoom, setZoom }),
  ];

  const formatDate = date => moment.unix(date).format('DD-MM-YYYY');

  const fileName = `${title}_${formatDate(dateRange.startDate)}_${formatDate(dateRange.endDate)}`;

  if (!inApp) {
    actions.push(...[
      (
        <IconButton key="download" onClick={() => FileSaveer.saveAs(data[0].reportDownloadUri, `${fileName}.pdf`)}>
          <Icon>
            save_alt
          </Icon>
        </IconButton>
      ),
      (
        <IconButton key="print" onClick={() => printJS(data[0].reportDownloadUri)}>
          <Icon>
            print
          </Icon>
        </IconButton>
      ),

    ]);

    if (supportsCsvExport) {

      if (isLoadingCsvExport) {
        actions.push(
          <Button key="csv_download_loading" style={styles.textButton}>
            <LoadingIndicator />
          </Button>
        )
      } else {
        actions.push(
          (
            <Button key="csv_download" 
              style={styles.textButton} 
              onClick={() => downloadCsvReportData({ widgetId: reportWidgetID, fileName: `${fileName}.csv` })}>
              CSV Export
            </Button>
          )
        )
      }
    }
  }

  if (!useDesktopLayout) {
    return (
      <>
        <IconButton
          className="doNotPrint"
          onClick={e => setAnchorEl(e.currentTarget)}
        >
          <Icon>more_vert</Icon>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={() => setAnchorEl(null)}
        >
          {actions.map(a => (
            <MenuItem>
              {a}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }


  return (
    <div style={styles.actions}>
      {actions}
    </div>
  );
};


const PdfVisualizer = ({
  classes, data, title, useDesktopLayout, inApp, dateRange, downloadCsvReportData, reportWidgetID, supportsCsvExport, isLoadingCsvExport,
}) => {
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    // try cactch for local storage access issues
    try {
      const zoom = localStorage.getItem('defaultZoom');
      if (zoom) {
        setZoom(+zoom);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);
  
  debugger
  const [zoom, setZoom] = useState(useDesktopLayout ? 180 : 100);

  useEffect(() => {
    try {
      localStorage.setItem('defaultZoom', zoom);
    } catch (e) {
      console.error(e);
    }  
  }, [zoom]);

  const [pageNumber, setPageNumber] = useState(1);
  
  const [anchorEl, setAnchorEl] = useState(null);

  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [wrapperHeight, setWrapperHeight] = useState(0);
  const [pageWidth, setPageWidth] = useState(0);
  const [pageHeight, setPageHeight] = useState(0);

  const fitHorizontal = useMemo(() => {
    const wRatio = pageWidth / wrapperWidth;
    const hRatio = pageHeight / wrapperHeight;
    if (wRatio < hRatio) {
      return false;
    }
    return true;
  }, [pageHeight, pageWidth, wrapperHeight, wrapperWidth]);

  const setWrapperDimensions = useCallback((w, h) => {
    setWrapperWidth(w);
    setWrapperHeight(h);
  }, []);


  if (!data || data.length === 0 || !data[0].reportDownloadUri) {
    return 'Bericht konnte nicht geladen werden';
  }

  const onDocumentLoadSuccess = ({ numPages: actualNumPages }) => {
    setNumPages(actualNumPages);
  };

  const changeToPage = (page) => {
    setPageNumber(() => page);
  };

  return (
    <Card style={inApp ? styles.cardInApp : styles.card}>
      <CardHeader
        title={title}
        action={header({
          numPages,
          pageNumber,
          changeToPage,
          zoom,
          setZoom,
          data,
          anchorEl,
          setAnchorEl,
          useDesktopLayout,
          inApp,
          title,
          dateRange,
          downloadCsvReportData,
          reportWidgetID,
          supportsCsvExport,
          isLoadingCsvExport,
        })}
      />
      <Measure
        bounds
        onResize={contentRect => setWrapperDimensions(contentRect.bounds.width, contentRect.bounds.height)}
      >
        {({ measureRef }) => (
          <CardContent style={styles.content} ref={measureRef}>
            <Document
              file={data[0].reportDownloadUri}
              onLoadSuccess={onDocumentLoadSuccess}
              className={classes.document}
            >
              <Page
                pageNumber={pageNumber}
                scale={zoom / 100}
                onLoadSuccess={(page) => {
                  setPageWidth(page.width);
                  setPageHeight(page.height);
                }}
                width={fitHorizontal ? (wrapperWidth - (contentPadding * 2 + documentBorderSize * 2)) : null}
                height={!fitHorizontal ? (wrapperHeight - (contentPadding * 2 + documentBorderSize * 2)) : null}
              />
            </Document>
          </CardContent>
        )}
      </Measure>
    </Card>
  );
};

PdfVisualizer.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  useDesktopLayout: PropTypes.bool.isRequired,
  inApp: PropTypes.bool.isRequired,
  supportsCsvExport: PropTypes.bool.isRequired,
  isLoadingCsvExport: PropTypes.bool.isRequired,
  dateRange: PropTypes.object.isRequired,
  downloadCsvReportData: PropTypes.func.isRequired,
};

export default withStyles(styles)(PdfVisualizer);
